// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"ba416ea5","93":"fe8bffee","277":"a01a5ff3","298":"c3775231","346":"feac439e","401":"e62e28b8","417":"1f2fcfb8","423":"0850965f","599":"bf8755e3","624":"62bd1afc","747":"1c2c5093","787":"9e9f4ffd","794":"88c1b529","834":"d4e62ff6"}[chunkId] + ".chunk.js";
};